import { render } from "./UploadContractModal.vue?vue&type=template&id=aa3c1e16&ts=true"
import script from "./UploadContractModal.vue?vue&type=script&lang=ts"
export * from "./UploadContractModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__